module.exports = "<div class=\"radio inline\">\n\t<label>\n\t  <input\n\t  \ttype=\"radio\"\n\t  \tclass=\"ace\"\n\t  \t[value]=\"value\"\n\t  \t[checked]=\"checked\"\n\t  \t[name]=\"name\"\n\t  \t(change)=\"onInputChange($event)\"/>\n\t  <span class=\"lbl\">\n\t  \t<ng-content></ng-content>\n\t  </span>\n\t</label>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/radio/radio.html
// module id = 537
// module chunks = 0